import { api } from "assets/scripts/utilities/api-clients";

export const get = async (options) => {
  const response = await api.get(
    `/voucher-association/${options.type}/${options.id}`,
  );

  return response;
};
